import { put, select } from "redux-saga/effects";
import { parse as deserializeQueryParams } from "query-string";

import { ScreenerStore } from "../model";
import { allFieldConfiguration } from "../../fields";
import { filterSet, preferenceSetConcreteEtfs } from "../actions";

export function* paramsToQueryStringDeserialize() {
	const store: ScreenerStore = yield select();

	const queryString: { [key: string]: string } = { };

	const possibleQueryString = deserializeQueryParams(window.location.search);
	for (var key in possibleQueryString) {
		const possibleValues = possibleQueryString[key];
		if (possibleValues === null)
			continue;
		if (possibleValues instanceof Array)
			continue;
		
		queryString[key] = possibleValues;
	}

	if (queryString["tickers"]) {
		var tickers = queryString["tickers"].split(',').map(x => x.trim());
		yield put(preferenceSetConcreteEtfs(tickers))
	}
	else {
		yield put(preferenceSetConcreteEtfs(null));
	}

	const newFilter = { ...store.filter, inputs: { ...store.filter.inputs } };
	for (const fieldConfiguration of allFieldConfiguration) {
		var input = newFilter.inputs[fieldConfiguration.systemName];
		var newInput = { ...input };
		fieldConfiguration.deserializeValue(newInput, queryString);

		newFilter.inputs[fieldConfiguration.systemName] = newInput;
	}

	yield put(filterSet(newFilter));
}
